<!--@keyup="$emit('update:data1', $event.target.value)"-->
<template>
    <div id="combinaison">

        <!--CONTAINERS 1-->
        <b-row>
            <b-col xs="4" sm="4" md="4" lg="4" xl="4">
                <div class="itemMain">
                    <div class="itemSubTitle">Sous-Titre</div>
                    <div class="itemContain">
                        Exemple de texte
                        <br><br><br><br><br><br>
                        Exemple de texte
                    </div>
                </div>
            </b-col>
            <b-col xs="8" sm="8" md="8" lg="8" xl="8" align="left">
                <b>Code :</b> <br><br>
                &lt;div class="itemMain"&gt;<br>
                    <span class="tab1">&lt;div class="itemSubTitle"&gt;<span class="red">Titre</span>&lt;/div&gt;</span><br>
                    <span class="tab1">&lt;div class="itemContain"&gt;</span><br>
                        <span class="tab2 red">Contenu</span><br>
                    <span class="tab1">&lt;/div&gt;</span><br>
                &lt;/div&gt;
            </b-col>
        </b-row>

        <!--COLLAPSE 1-->
        <br><br>
        <b-row>
            <b-col xs="4" sm="4" md="4" lg="4" xl="4">
                <h6 class="subTitle3 cursorPoint" @mousedown="collaps = !collaps">{{collaps == true ? '-' : '+'}} Titre</h6>
                    <span v-show="collaps">
                        <!--Format-->
                        <b-row align-v="center">
                            <span class="MargeLeft15">Exemple de texte<br>Exemple de texte<br>Exemple de texte</span>
                        </b-row>
                    </span>
            </b-col>
            <b-col xs="8" sm="8" md="8" lg="8" xl="8" align="left">
                <b>Code :</b> <br><br>
                <span class="darkGreen">Dans le data on doit déclarer la variable : </span><span class="blue">collaps: false</span><br><br>

                &lt;h6 class="subTitle3 cursorPoint" @mousedown="collaps = !collaps"&gt;{{'{{ collaps == true ? '}} &apos;-&apos; : &apos;+&apos; }} <span class="red">Titre</span>&lt;/h6&gt;<br>
                    <span class="tab1">&lt;span v-show="collaps"&gt;</span><br>
                        <span class="tab2">&lt;b-row align-v="center"&gt;</span><br>
                            <span class="tab3 red">Contenu</span><br>
                        <span class="tab2">&lt;/b-row&gt;</span><br>
                    <span class="tab1">&lt;/span&gt;</span>
            </b-col>
        </b-row>

        <!--CONTAINERS + COLLAPSE 1-->
        <br><br>
        <b-row>
            <b-col xs="4" sm="4" md="4" lg="4" xl="4">

                <div class="itemMain">
                    <div class="itemSubTitle">Sous-Titre</div>
                    <div class="itemContain">
                        Exemple de texte
                        <br><br><br>
                        Exemple de texte

                        <h6 class="subTitle3 cursorPoint" @mousedown="collaps2 = !collaps2">{{collaps2 == true ? '-' : '+'}} Titre</h6>
                            <span v-show="collaps2">
                                <!--Format-->
                                <b-row align-v="center">
                                    <span class="MargeLeft15">Exemple de texte<br>Exemple de texte<br>Exemple de texte</span>
                                </b-row>
                            </span>

                    </div>
                </div>

            </b-col>
            <b-col xs="8" sm="8" md="8" lg="8" xl="8" align="left">
                
                <b>Code :</b> <br><br>
                <span class="darkGreen">Dans le data on doit déclarer la variable : </span><span class="blue">collaps: false</span><br><br>

                &lt;div class="itemMain"&gt;<br>
                    <span class="tab1">&lt;div class="itemSubTitle"&gt;<span class="red">Titre</span>&lt;/div&gt;</span><br>
                    <span class="tab1">&lt;div class="itemContain"&gt;</span><br>
                        <span class="tab2 red">Contenu</span><br>

                        

                        <span class="tab2">&lt;h6 class="subTitle3 cursorPoint" @mousedown="collaps = !collaps"&gt;{{'{{ collaps == true ? '}} &apos;-&apos; : &apos;+&apos; }} <span class="red">Titre</span>&lt;/h6&gt;</span><br>
                            <span class="tab2">&lt;span v-show="collaps"&gt;</span><br>
                                <span class="tab3">&lt;b-row align-v="center"&gt;</span><br>
                                    <span class="tab4 red">Contenu</span><br>
                                <span class="tab3">&lt;/b-row&gt;</span><br>
                            <span class="tab2">&lt;/span&gt;</span>

                    <span class="tab2">&lt;/div&gt;</span><br>
                &lt;/div&gt;

            </b-col>
        </b-row>


    </div>
</template>

<script>
import {mapGetters} from 'vuex'

export default{
    name: 'combinaison',
    components: {
},
    props: ['leftSize', 'deptList', 'DNumber'],
    data() {
        return {
            collaps: false,
            collaps2: false,
        }
    },
    methods: {

    },
    computed: {
        ...mapGetters(['getTheme']),
        _DNumber: {
            get: function() {return this.DNumber},
            set: function(modifiedValue){this.$emit('update:DNumber', modifiedValue)}
        }
    }
}
</script>

<style lang="scss" scoped>
.red{
    color: red;
}
.blue{
    color: blue;
}
.darkGreen{
    color: darkgreen;
}
.tab1 {
    margin-left: 20px;
}

.tab2 {
    margin-left: 40px;
}

.tab3 {
    margin-left: 60px;
}

.tab4 {
    margin-left: 80px;
}
</style>